<div class="dropdown" #profileDropdown>
    <button class="dropdown__avatar" (click)="toggleItems()" type="button">
        {{ initialText }}
    </button>
    <div
        class="dropdown__items"
        [class.dropdown__items--visible]="showItems"
        [class.dropdown__items--right]="dropdownPosition === 'right'"
        [class.dropdown__items--not-admin]="dropdownPosition === 'right'"
    >
        <div class="dropdown__item dropdown__item--primary" (click)="toggleItems()">
            <img src="/assets/icons/email.svg" alt="Icon" />
            <span class="dropdown__item__text">{{ userData?.email ?? 'user@mail.com' }}</span>
        </div>
        <div class="dropdown__divider"></div>
        <div class="dropdown__item dropdown__item--primary" (click)="toggleItems(); logout.emit()">
            <img src="/assets/icons/logout.svg" alt="Icon" />
            <span class="dropdown__item__text">Logout</span>
        </div>
    </div>
</div>
